import { TbCheckbox } from 'react-icons/tb';
import type { IconProps } from './IconBase';
import { IconBase } from './IconBase';

export const TaskIcon = (props: IconProps) => {
  return <IconBase icon={TbCheckbox} {...props} />;
};
